import React from "react"
import styled from "styled-components"

import RouterLink from "@irati/ui/src/Link/RouterLink"
import {FormattedMessage} from "@irati/utils/lang"
import id from "@irati/utils/id"
import padding from "@irati/ui/src/global/padding"

import sitemap from "../../../routes/sitemap"

const StyledRouterLink = styled(RouterLink)`
  padding-left: 10px;
`
const BackToHomepage = styled.div`
  padding-top: ${padding.medium};
  display: flex;
`
const LinkWrapper = styled.div`
  font-size: 14px;
`

const GoToHomepage = ({...props}) => {
  const idNamespace = id("go-to-homepage", props)
  return (
    <BackToHomepage>
      <FormattedMessage id="insights.wizard.launchLater" />
      <StyledRouterLink id={idNamespace} to={sitemap.homepage.url} inBody uppercase={false}>
        <LinkWrapper>
          <FormattedMessage id="insights.wizard.backToHomepage" />
        </LinkWrapper>
      </StyledRouterLink>
    </BackToHomepage>
  )
}

export default GoToHomepage
